export default [{
  path: '/myCoupons',
  name: 'myCoupons',
  component: () => import('@/views/my-coupons/index'),
}]
